import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  connect() {
    document
      .querySelectorAll(
        "#week5-choice-1,#week5-choice-2,#week5-choice-3,#week5-choice-4"
      )
      .forEach((button) => {
        button.addEventListener("click", () => {
          if (isFoodInSlot(button, 1) || isFoodInSlot(button, 2)) {
            return;
          }
          if (isSlotCorrect(1)) {
            if (!isSlotCorrect(2)) {
              addFoodToSlot(button, 2);
              if (isButtonCorrect(button)) {
                markSlotCorrect(2);
                this.enableNextNavigation();
              }
            }
          } else {
            addFoodToSlot(button, 1);
            if (isButtonCorrect(button)) {
              markSlotCorrect(1);
            }
          }
        });
      });

    function isFoodInSlot(foodButton, slotNumber) {
      return slot(slotNumber).dataset.food == foodButton.dataset.food;
    }

    function isSlotCorrect(slotNumber) {
      return slot(slotNumber).dataset.isCorrect == "true";
    }

    function markSlotCorrect(slotNumber) {
      slot(slotNumber).dataset.isCorrect = "true";
    }

    function addFoodToSlot(foodButton, slotNumber) {
      slot(slotNumber).innerHTML = foodButton.querySelector("img").outerHTML;
      slot(slotNumber).dataset.food = foodButton.dataset.food;
      displayFeedback(foodButton.dataset.food);
    }

    function isButtonCorrect(foodButton) {
      return foodButton.dataset.isCorrect == "true";
    }

    function slot(slotNumber) {
      return document.getElementById("week5-food-" + slotNumber);
    }

    function displayFeedback(food) {
      document.querySelectorAll(".game.feedback").forEach(function (feedback) {
        feedback.style.display = "none";
      });
      const feedbackContainer = document.getElementById(food + "-feedback");
      feedbackContainer.style.display = "block";
      feedbackContainer.querySelector('.feedback').style.display = "block";
    }
  }

  disableNextNavigation() {
    this.pageNavNext.setAttribute("disabled", "disabled");
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }
}
